export const ClampedText = () => {
    const clampedTexts = [...document.querySelectorAll('.clamp__text')]

    window.addEventListener('resize', (event) => {
        for (let text of clampedTexts) {
            const toggle = text.nextElementSibling
            toggle.classList.toggle('visually-hidden', text.scrollHeight <= text.clientHeight)
        }
    }, false)


    for (let text of clampedTexts) {
        const toggle = text.nextElementSibling

        toggle.classList.toggle('visually-hidden', text.scrollHeight <= text.clientHeight)

        toggle.addEventListener('click', evt => {
            evt.preventDefault()
            const display = text.style.getPropertyValue("--display")
            if (display === "block") {
                toggle.innerText = toggle.dataset.showMore
                text.style.setProperty("--display", "-webkit-box");

            }
            else {
                toggle.innerText = toggle.dataset.showLess
                text.style.setProperty("--display", "block");
            }
        })
    }
}